import { useRef, useState } from 'react'

import cn from 'classnames'

import styles from './styles.module.scss'
import RabbitImg from './images/rabbit.svg'
import ExchangeQuestion from './exchange-question'
import { ExchangeFaqProps } from './exchange-faq.props'
import { useTranslation } from 'utils/use-translation'

export default function ExchangeFaq({ questions, className, hasTitle = true, ...props }: ExchangeFaqProps) {
  const { t } = useTranslation()

  const [currentId, setCurrentId] = useState<number>(-1)
  const imageRef = useRef(null)

  const handleOpen = (index: number) => {
    if (currentId === index) {
      setCurrentId(-1)
    } else {
      setCurrentId(index)
    }
  }

  return (
    <div className={cn(styles.faq, className)} {...props}>
      <img ref={imageRef} className={styles.faq__img} src={RabbitImg} alt="rabbit image" />
      <div className={styles.questions}>
        {hasTitle && <h2>{t('faq')}</h2>}

        {questions.map((question, index) => (
          <>
            <ExchangeQuestion
              key={index}
              question={question}
              currentId={currentId}
              questionId={index}
              handleOpen={() => handleOpen(index)}
            />
            <hr color="#cfe1fc" />
          </>
        ))}
      </div>
    </div>
  )
}
